import { useEffect } from 'react';
import { Modal, notification } from 'antd';
import { useSelector } from 'react-redux';

import {
  getSelectedLists,
  getView,
  getIncludePausedLists,
  getShowMyListsOnly,
} from 'selectors/lists';
import { usePost } from 'hooks';
import { bulkDeleteList } from 'services/api';
import { deletePermissionsError } from '../constants';

const BulkDelete = ({ onClose }) => {
  const view = useSelector(getView);
  const members = useSelector(getSelectedLists);
  const includePausedLists = useSelector(getIncludePausedLists);
  const showMyListsOnly = useSelector(getShowMyListsOnly);

  const [{ res: success, loading, error }, postDelete] = usePost({
    url: bulkDeleteList(view),
  });

  useEffect(() => {
    if (success) {
      onClose({
        bulkDelete: true,
        ids: Object.keys(members.include).map(x => +x),
      });
    }
  }, [onClose, success, members.include]);

  useEffect(() => {
    if (error) {
      onClose();
    }
    if (error?.status === 412) {
      notification.open({
        message: 'Invalid List Operation',
        description: <div>{deletePermissionsError}</div>,
        placement: 'bottomLeft',
      });
    }
  }, [error, onClose, success]);

  const handleDelete = () => {
    postDelete({
      applyToAll: members.all,
      ids: Object.keys(members.include).map(x => +x),
      excludeIds: Object.keys(members.exclude).map(x => +x),
      includeDisabled: includePausedLists,
      onlyShowMine: showMyListsOnly,
    });
  };

  return (
    <Modal
      open
      title='Bulk Delete'
      onCancel={onClose}
      onOk={handleDelete}
      okText='Yes'
      okButtonProps={{ disabled: loading }}
      cancelButtonProps={{ disabled: loading }}
    >
      Are you sure you want to delete selected lists?
    </Modal>
  );
};

export default BulkDelete;
